import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';

export function useUsage(session) {
  const [used, setUsed] = useState(0);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!session?.access_token) return;
    try {
      const res = await axios.get(`${API}/usage`, {
        headers: { Authorization: `Bearer ${session.access_token}` },
      });
      setUsed(res.data.used ?? 0);
      setLimit(res.data.limit ?? 10);
    } catch {
      // ignore — usage endpoint may not exist yet
    } finally {
      setLoading(false);
    }
  }, [session]);

  useEffect(() => { refresh(); }, [refresh]);

  return { used, limit, loading, refresh, atLimit: used >= limit };
}
